// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Networks.css — Responsive overrides for src/pages/Networks.jsx
 * Loads AFTER index.css so it wins at equal specificity.
 * The inline \\3c style> in Networks.jsx is injected at runtime into the
 * document head; to reliably win we use .networks-page as a scope prefix
 * (already on the root div) which gives us one extra class of specificity.
 * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px
 */

/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */
@media (max-width: 991px) {
  /* Shrink the grid minimum so 2 cards still fit on large tablets */
  .networks-page .networks-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  /* ── Page container: kill horizontal scroll ── */
  .networks-page {
    overflow-x: hidden;
  }

  /* ── Header actions: full-width buttons when they wrap ── */
  .networks-page .nt-header-actions {
    width: 100%;
  }

  .networks-page .nt-header-actions .rd-btn {
    flex: 1 1;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Search / filter bar: wrap to two rows ── */
  .networks-page .search-filter-bar {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Search box stays full width */
  .networks-page .search-filter-bar .search-box {
    flex: 1 1 100%;
    min-height: 44px;
  }

  /* Filter and refresh buttons share the second row, full tappable area */
  .networks-page .search-filter-bar .btn-filter {
    flex: 1 1;
    justify-content: center;
    min-height: 44px;
  }

  .networks-page .search-filter-bar .btn-icon-only {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Networks grid: single column ── */
  .networks-page .networks-grid {
    grid-template-columns: 1fr;
  }

  /* ── Network card: comfortable padding on narrow screen ── */
  .networks-page .network-card {
    padding: 1rem;
  }

  /* ── Admin icon buttons: ensure 44px tap targets ── */
  .networks-page .btn-icon {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  /* ── Premium upsell banner: stack on narrow screens ── */
  .networks-page .nt-upsell {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .networks-page .nt-upsell-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Modals → bottom sheets ── */
  /*
   * The inline \\3c style> positions .modal-overlay as a centered flex
   * container. On mobile we override it to anchor modals at the bottom.
   * Modals render inside .networks-page so we scope with that prefix.
   */
  .networks-page .modal-overlay {
    align-items: flex-end;
    padding: 0;
    /* Reserve room for the fixed bottom nav (≈56px) + home-bar so the
       sheet (and its footer buttons) sit above the nav, not behind it. */
    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  }

  .networks-page .modal-container {
    max-width: 100% !important;
    width: 90% !important;
    border-radius: 16px 16px !important;
    /* Cap height after the reserved nav space so it never overflows the viewport */
    max-height: calc(100dvh - 56px - env(safe-area-inset-bottom, 0px) - 8px) !important;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
  }

  /* Footer rounded corners must follow the sheet corners; stack buttons */
  .networks-page .modal-footer {
    border-radius: 0 !important;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .networks-page .modal-footer .btn-secondary,
  .networks-page .modal-footer .btn-primary,
  .networks-page .modal-footer .btn-danger {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.25rem);
    justify-content: center;
    min-height: 44px;
  }

  /* ── Form rows inside modals: single column ── */
  .networks-page .modal-body .form-row {
    grid-template-columns: 1fr !important;
  }

  /* ── Form inputs: comfortable height for tapping ── */
  .networks-page .modal-body .form-group input,
  .networks-page .modal-body .form-group select {
    min-height: 44px;
    font-size: 1rem; /* prevents iOS auto-zoom on focus */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Networks.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,gFAAgF;AAChF;EACE,kEAAkE;EAClE;IACE,4DAA4D;EAC9D;AACF;;AAEA,gFAAgF;AAChF;EACE,iDAAiD;EACjD;IACE,kBAAkB;EACpB;;EAEA,4DAA4D;EAC5D;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,eAAe;IACf,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,wEAAwE;EACxE;IACE,SAAO;IACP,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;EAC5B;;EAEA,6DAA6D;EAC7D;IACE,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;;EAEA,yDAAyD;EACzD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;;;;IAIE;EACF;IACE,qBAAqB;IACrB,UAAU;IACV;yEACqE;IACrE,6DAA6D;EAC/D;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,mCAAmC;IACnC,+EAA+E;IAC/E,mFAAmF;IACnF,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,SAAS;EACX;;EAEA,wEAAwE;EACxE;IACE,2BAA2B;IAC3B,eAAe;IACf,WAAW;EACb;;EAEA;;;IAGE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,qCAAqC;EACvC;;EAEA,sDAAsD;EACtD;;IAEE,gBAAgB;IAChB,eAAe,EAAE,oCAAoC;EACvD;AACF","sourcesContent":["/*\n * Networks.css — Responsive overrides for src/pages/Networks.jsx\n * Loads AFTER index.css so it wins at equal specificity.\n * The inline <style> in Networks.jsx is injected at runtime into the\n * document head; to reliably win we use .networks-page as a scope prefix\n * (already on the root div) which gives us one extra class of specificity.\n * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px\n */\n\n/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */\n@media (max-width: 991px) {\n  /* Shrink the grid minimum so 2 cards still fit on large tablets */\n  .networks-page .networks-grid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n}\n\n/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  /* ── Page container: kill horizontal scroll ── */\n  .networks-page {\n    overflow-x: hidden;\n  }\n\n  /* ── Header actions: full-width buttons when they wrap ── */\n  .networks-page .nt-header-actions {\n    width: 100%;\n  }\n\n  .networks-page .nt-header-actions .rd-btn {\n    flex: 1;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Search / filter bar: wrap to two rows ── */\n  .networks-page .search-filter-bar {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Search box stays full width */\n  .networks-page .search-filter-bar .search-box {\n    flex: 1 1 100%;\n    min-height: 44px;\n  }\n\n  /* Filter and refresh buttons share the second row, full tappable area */\n  .networks-page .search-filter-bar .btn-filter {\n    flex: 1;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  .networks-page .search-filter-bar .btn-icon-only {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ── Networks grid: single column ── */\n  .networks-page .networks-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* ── Network card: comfortable padding on narrow screen ── */\n  .networks-page .network-card {\n    padding: 1rem;\n  }\n\n  /* ── Admin icon buttons: ensure 44px tap targets ── */\n  .networks-page .btn-icon {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  /* ── Premium upsell banner: stack on narrow screens ── */\n  .networks-page .nt-upsell {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .networks-page .nt-upsell-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Modals → bottom sheets ── */\n  /*\n   * The inline <style> positions .modal-overlay as a centered flex\n   * container. On mobile we override it to anchor modals at the bottom.\n   * Modals render inside .networks-page so we scope with that prefix.\n   */\n  .networks-page .modal-overlay {\n    align-items: flex-end;\n    padding: 0;\n    /* Reserve room for the fixed bottom nav (≈56px) + home-bar so the\n       sheet (and its footer buttons) sit above the nav, not behind it. */\n    padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .networks-page .modal-container {\n    max-width: 100% !important;\n    width: 90% !important;\n    border-radius: 16px 16px !important;\n    /* Cap height after the reserved nav space so it never overflows the viewport */\n    max-height: calc(100dvh - 56px - env(safe-area-inset-bottom, 0px) - 8px) !important;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    left: 50%;\n  }\n\n  /* Footer rounded corners must follow the sheet corners; stack buttons */\n  .networks-page .modal-footer {\n    border-radius: 0 !important;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .networks-page .modal-footer .btn-secondary,\n  .networks-page .modal-footer .btn-primary,\n  .networks-page .modal-footer .btn-danger {\n    flex: 1 1 calc(50% - 0.25rem);\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Form rows inside modals: single column ── */\n  .networks-page .modal-body .form-row {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* ── Form inputs: comfortable height for tapping ── */\n  .networks-page .modal-body .form-group input,\n  .networks-page .modal-body .form-group select {\n    min-height: 44px;\n    font-size: 1rem; /* prevents iOS auto-zoom on focus */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
